import React from 'react';

import styled, { css } from 'styled-components/macro';

type InputProps = {
  fontSize?: string;
  fontFamily?: string;
  color?: string;
  textAlign?: 'center' | 'right';
};

const baseInputStyles = css<InputProps>`
  font-family: 'Kanit', 'Roboto', sans-serif;
  font-size: ${({ fontSize }) => fontSize};
  font-family: ${({ fontFamily }) => fontFamily};
  color: ${({ color }) => color};
  text-align: ${({ textAlign }) => textAlign};
  background: rgba(0, 0, 0, 0);
  border: none;
  width: 100%;
`;

const Input = styled.input<InputProps>`
  ${baseInputStyles}
`;

const TextArea = styled.textarea<InputProps>`
  ${baseInputStyles}
  max-width: 100%;
`;

type InputTextProps = {
  onChange?: (e: any) => void;
  onClick?: (e: any) => void;
  value?: string;
} & InputProps;

export const InputText = (props: InputTextProps): JSX.Element => {
  return <Input type='text' {...props} />;
};

export const InputTextArea = (props: InputTextProps): JSX.Element => {
  return <TextArea {...props} />;
};

export default InputText;
